



















import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Listitem } from '@/data/models/listitem.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';

@Component
export default class ListSelect extends Vue {
	@Prop() value!: string;
	@Prop() list!: string;
	@Prop() placeholder?: string;
	@Prop({ default: false }) emptyOption!: boolean;
	@Prop({ default: false }) disabled?: boolean;

	@Inject('CrudService') crudService!: CrudService<Listitem>;

	items: Listitem[] = [];
	loading: boolean = false;

	@Watch('list', { immediate: true })
	onListChange(value: string) {
		if (value) {
			this.loadData();
		} else {
			this.items = [];
		}
	}

	loadData() {
		this.loading = true;
		const search = new Search(
			'selistitem join selist on selist.id = selistitem.lid'
		);
		search.addSimpleFilter('selist.slug', this.list);
		search.setSortDirection(SortDirection.ASCENDING);
		search.setSortField('sort');

		const page = new Page(100);
		page.setPageNumber(0);
		this.crudService
			.searchEntities(Listitem, 'selistitem', search, page)
			.then((result) => (this.items = result))
			.finally(() => (this.loading = false));
	}

	get newValue(): string {
		return this.value;
	}

	set newValue(value: string) {
		this.$emit('input', value);
	}
}
